import { defineMessages } from 'react-intl';

export default defineMessages({
  description: 'Connect your wallet and jump into DeFi',

  titleBrowserWallet: '{walletName} Wallet',
  noBrowserBrowserWallet: 'No browser wallet detected.',

  continueWithoutWallet: 'or continue without wallet',
  errorCaption: 'Error detected',

  needHelp: 'Need help connecting a wallet? {readOurFAQ}',
  readOurFAQ: 'Read our FAQ',

  disclaimerBottomText:
    '{disclaimer} Wallets are provided by External Providers and by selecting you agree to Terms of those Providers. Your access to the wallet might be reliant on the External Provider being operational.',
  disclaimer: 'Disclaimer:',
});
